angular.module('impactx.search').component('ixProductList', {
        bindings: {
            products: '<',
            trns: '<',
            vCatId: '<',
            noNameSort: '<'
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'ProductListCtrl',
        controllerAs: 'productListCtrl',
        templateUrl: 'modules/search/templates/product-list.html'
    }
);